import moment from 'moment';
import uuidv1 from 'uuid/v1';
import Workout from './Workout';

class Wod {
  constructor({
    _id = null,
    date = null,
    name = '',
    image,
    workouts = [],
    active = false,
  }) {
    const { id: imageId = null, url: imageUrl = '' } = image ? image : {};
    this.key = uuidv1();
    this.id = _id;
    this.date = date ? moment(date) : null;
    this.name = name;
    this.image = {
      id: imageId,
      url: imageUrl,
    };
    this.workouts = workouts.map((workoutData) => new Workout(workoutData));
    this.active = active;
  }
}

export default Wod;
